import Stack from "@mui/material/Stack";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import KhattabatMessages from "./messages/KhattabatMessages";
import KhattabatCreateOneOTwo from "./side-actions/KhattabatCreateOneOTwo";
import KhattabatMarkAsReadButton from "./side-actions/KhattabatMarkAsReadButton";
import KhattabatReactivateConversation from "./side-actions/KhattabatReactivateConversation";
import KhattabatReactivateKhattabaClient from "./side-actions/KhattabatReactivateKhattabaClient";
import getCorePersonalStore from "../../../../../stores/core/core-personal-store";
import getKhattabatSharedMessagingStore from "../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";

const Body = withLiteObserverAndTheme<{
  conversationID: string;
  userID: number;
}>((props) => {
  const { conversationID, userID } = props;
  const { isOpened } = getKhattabatSharedMessagingStore(conversationID);

  const isConversationOpen = isOpened.get() === "OPENED";
  const isAiKhattaba = getCorePersonalStore().isKhattabaAiAdmin.get();

  return isConversationOpen ? (
    <Stack spacing={1.5} sx={{ p: 1, bgcolor: "background.paper" }}>
      {isAiKhattaba ? null : (
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          flexWrap="wrap"
          useFlexGap
        >
          <KhattabatMarkAsReadButton
            userID={userID}
            conversationID={conversationID}
          />
          <KhattabatCreateOneOTwo
            conversationID={conversationID}
            userID={userID}
          />
          <KhattabatReactivateKhattabaClient
            userID={userID}
            conversationID={conversationID}
          />
          <KhattabatReactivateConversation conversationID={conversationID} />
        </Stack>
      )}
      <KhattabatMessages conversationID={conversationID} userID={userID} />
    </Stack>
  ) : null;
});

export default Body;
